import { GET_REFERRALS, SEND_INVITE, SHOW_ALERT } from "../action-types";

import { getReferralSuccess } from "../mutation-types";

import { DEFAULT_ERROR_MESSAGE } from "@/store/config";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";

const state = {
	retailerReferralHistory: [],
	retailReferralHistoryOffset: null
};

const actions = {
	[GET_REFERRALS.action]: (
		{ commit, dispatch, rootState, state },
		{ type, ...payload }
	) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/getReferrals";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload,
				...(type === "end"
					? { startFrom: state.retailReferralHistoryOffset }
					: {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.referrals &&
					Array.isArray(data.response.referrals)
				) {
					commit(getReferralSuccess, { ...data.response, type });
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[SEND_INVITE.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/smsInvite";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: payload
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.status === "success"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Invite Sent Successfully!" },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	}
};

const mutations = {
	[getReferralSuccess](state, { referrals, lastKey, type }) {
		if (type === "end") {
			state.retailReferralHistory = state.retailReferralHistory.concat(
				referrals
			);
		} else {
			state.retailReferralHistory = referrals;
		}
		state.retailReferralHistoryOffset = lastKey;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
